import { z, isoZ } from 'my-zod'

export const modelForecastType = z.enum(['ORV', 'SLG', 'IMX'])
export type modelForecastType = z.infer<typeof modelForecastType>

export const modelForecastStatusEnum = z.enum(['InProgress', 'Approved', 'Archived'])
export type modelForecastStatus = z.infer<typeof modelForecastStatusEnum>
export const modelForecastStatuses = modelForecastStatusEnum.Enum

export const modelForecastLine = z.object({
  forecastId: z.string().uuid(),
  modelId: z.number(),
  yearMonth: isoZ.yearMonth(),
  quantity: z.number().min(0)
})
export type modelForecastLine = z.infer<typeof modelForecastLine>

export const modelForecastsModel = z.object({
  id: z.string().uuid(),
  shortId: z.string().nonempty(),
  name: z.string().nullable(),
  type: modelForecastType,
  status: modelForecastStatusEnum.nullable(),
  approvalDate: isoZ.instant().nullable(),
  lines: modelForecastLine.array().min(1),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullish()
})

export type modelForecastsModel = z.infer<typeof modelForecastsModel>
